module.exports = __webpack_public_path__ + "img/ss6.9f05adfd.jpg";